import PageHeader from '../commons/PageHeader';
import { Container, Divider } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useEffect, useState } from "react";
import PhotoDayImportField from './PhotoDayImportField';
import PhotoDayImportResult from './PhotoDayImportResult'
import { importPhotoDay,  
          selectStatus, resetEventState, resetCompleteStatus } 
          from '../../app/slices/photoDayImportSlice';

function PhotoDayImport(){
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectStatus);
  const [initialized, setInitialized] = useState(false);
  const [resultField, setResultField] = useState(false);
  const [eventID, setEventId] = useState('');
  

    useEffect(() => {
        if (!initialized) {
          setInitialized(true);
        }
      }, [initialized]);

    const photoDayImport = (eventId: string) => {
        setEventId(eventId)
        if (eventId.length === 0) {
          alert('Please enter eventID');
          return;
        }
         dispatch(resetEventState())
         dispatch(importPhotoDay(eventId));
         setResultField(true);
         dispatch(resetCompleteStatus());
      };
    
    return (
        <>
        <PageHeader title='Upload PhotoDay Job' />
        <Container sx={{ textAlign: 'left' }}>
            <PhotoDayImportField 
            photoDayImportField={photoDayImport}
            loading={status === 'LOADING'}
            error={status === 'FAILED'}
            />
            <Divider sx={{ my: 4 }} />
            {resultField && < PhotoDayImportResult
            eventId={eventID}
            />}
            
        </Container>
        </>
    );
}

export default PhotoDayImport;
